
export const inventory = {
  productManagement: {
    title: "Medical Stock Management",
    addNew: "Add New Item",
    loading: "Loading Items...",
    loadingSupabase: "Fetching from Supabase...",
    loadingMock: "Using Mock Data...",
    errorTitle: "Error",
    errorMessage: "Could not load data.",
    countSupabase: "{{count}} items found (Live DB)",
    countMock: "{{count}} items (Mock Data)",
    deleteConfirm: "Are you sure you want to delete this product?",
    edit: "Edit",
    delete: "Delete",
    empty: "No products found.",
    emptySupabase: "Database is connected but empty.",
    tabs: {
      products: "Products",
      categories: "Categories"
    },
    table: {
      name: "Item Name",
      sku: "SKU",
      category: "Category",
      price: "Price",
      stock: "Stock",
      status: "Status",
      actions: "Actions"
    },
    statusActive: "Active",
    statusInactive: "Inactive"
  },
  pharmacy: {
    title: "Pharmacy Station",
    subtitle: "Dispensing and compliance logging.",
    refresh: "Refresh Queue",
    queue: "Dispensing Queue",
    searchQueue: "Search Name or ID...",
    statusApproved: "Approved",
    empty: "No approved prescriptions waiting.",
    approvedLabel: "APPROVED",
    posHint: "This amount has been reserved in the customer's quota.",
    stepsTitle: "Dispensing Process",
    steps: {
      1: "Verify patient identity.",
      2: "Check prescription details.",
      3: "Pick items from inventory.",
      4: "Label products.",
      5: "Explain usage to patient.",
      6: "Record Dispensing (Crucial for Compliance Report)"
    },
    printButton: "Download PDF / Print",
    dispenseButton: "Record Dispensing",
    selectPrompt: "Select a patient from the queue to view details.",
    dispenseModalTitle: "Record Dispensing (Pht.28)",
    modal: {
      warning: "This action will log the sale for the Monthly Report (Pht.28). Please ensure accuracy.",
      productName: "Dispensed Product Name",
      quantity: "Quantity",
      unit: "Unit",
      lot: "Lot Number / Batch ID",
      lotPlaceholder: "Optional",
      note: "Pharmacist Notes",
      confirm: "Confirm & Save"
    }
  },
  compliance: {
    title: "Compliance Reports",
    pht27: {
      title: "Pht. 27 (Receiving)",
      subtitle: "Source & Inventory Report"
    },
    pht28: {
      title: "Pht. 28 (Distribution)",
      subtitle: "Sales & Dispensing Report"
    },
    reportHeader27: "Form Pht. 27: Inventory Source",
    reportHeader28: "Form Pht. 28: Distribution Log",
    month: "Reporting Month:",
    export: "Export Excel",
    print: "Print Report"
  }
};
